import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';
import { SvgComponent } from '@components/svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthCredentialsFormComponent } from '@components/auth-credentials-form/auth-credentials-form.component';
import { UserModel } from '@models/user/user.model';

@Component({
  selector: 'app-modal-reauth',
  standalone: true,
  imports: [ModalCardComponent, SvgComponent, TranslateModule, AuthCredentialsFormComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-reauth.component.html',
})
export class ModalReauthComponent {
  cancelClick = output<void>();
  success = output<UserModel>();
}
